// extracted by mini-css-extract-plugin
export default {"container":"MenuPage_container__v7r-C","sections":"MenuPage_sections__EcoO1","subheader":"MenuPage_subheader__54xoM"};